module.exports = __webpack_public_path__ + "img/violet_002.1176e608.png";